export default __webpack_public_path__ + "b7af47f6be18506dd243da55a2c4b833.png";